import * as React from "react";
import { OI } from "../onam/mark";
import { FEATURES } from "../onam/features";

type Props = React.SVGProps<SVGSVGElement> & { title?: string };

function BaseTrailIcon({ title, ...props }: Props) {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden={title ? undefined : true}
      role="img"
      {...props}
    >
      {title ? <title>{title}</title> : null}
      <path
        d="M21.75 20.75H16.75V15.75H21.75V20.75ZM18 19.5H20.5V17H18V19.5ZM15.5 18.875H8C7.00544 18.875 6.05161 18.4799 5.34835 17.7767C4.64509 17.0734 4.25 16.1196 4.25 15.125C4.25 14.1304 4.64509 13.1766 5.34835 12.4733C6.05161 11.7701 7.00544 11.375 8 11.375H9.25V12.625H8C7.33696 12.625 6.70107 12.8884 6.23223 13.3572C5.76339 13.8261 5.5 14.462 5.5 15.125C5.5 15.788 5.76339 16.4239 6.23223 16.8928C6.70107 17.3616 7.33696 17.625 8 17.625H15.5V18.875Z"
        fill="currentColor"
      />
      <path
        d="M15.5 14.5H10.5V9.5H15.5V14.5ZM11.75 13.25H14.25V10.75H11.75V13.25Z"
        fill="currentColor"
      />
      <path
        d="M18 12.625H16.75V11.375H18C18.663 11.375 19.2989 11.1116 19.7678 10.6428C20.2366 10.1739 20.5 9.53804 20.5 8.875C20.5 8.21196 20.2366 7.57607 19.7678 7.10723C19.2989 6.63839 18.663 6.375 18 6.375H10.5V5.125H18C18.9946 5.125 19.9484 5.52009 20.6517 6.22335C21.3549 6.92661 21.75 7.88044 21.75 8.875C21.75 9.86956 21.3549 10.8234 20.6517 11.5267C19.9484 12.2299 18.9946 12.625 18 12.625ZM9.25 8.25H4.25V3.25H9.25V8.25ZM5.5 7H8V4.5H5.5V7Z"
        fill="currentColor"
      />
    </svg>
  );
}

/* With the ONAM skin (FEATURES.curationSkin) this draws ONAM's "trail" glyph instead (onam/mark.tsx). */
const TrailIconSkin = (props: any) =>
  FEATURES.curationSkin ? (
    <OI n="trail" size={props.size || 18} className={props.className} style={props.style} onClick={props.onClick} title={props.title} color={props.color}
      onMouseOver={props.onMouseOver} onMouseOut={props.onMouseOut} onMouseEnter={props.onMouseEnter} onMouseLeave={props.onMouseLeave} />
  ) : (
    <BaseTrailIcon {...props} />
  );
export default TrailIconSkin;
